// ---------------- Grant Application ----------------

import {actionCreator} from "../../helpers/redux/actionCreator";
import * as ActionTypes from "./types";

export const fetchCountries = actionCreator(ActionTypes.FETCH_COUNTRIES);
export const fetchCountriesSucceeded = actionCreator(ActionTypes.FETCH_COUNTRIES_SUCCEEDED);
export const fetchCountriesFailed = actionCreator(ActionTypes.FETCH_COUNTRIES_FAILED);

export const fetchCounties = actionCreator(ActionTypes.FETCH_COUNTIES);
export const fetchCountiesSucceeded = actionCreator(ActionTypes.FETCH_COUNTIES_SUCCEEDED);
export const fetchCountiesFailed = actionCreator(ActionTypes.FETCH_COUNTIES_FAILED);

export const fetchCurrencies = actionCreator(ActionTypes.FETCH_CURRENCIES);
export const fetchCurrenciesSucceeded = actionCreator(ActionTypes.FETCH_CURRENCIES_SUCCEEDED);
export const fetchCurrenciesFailed = actionCreator(ActionTypes.FETCH_CURRENCIES_FAILED);

export const findOrganization = actionCreator(ActionTypes.FIND_ORGANIZATION);
export const findOrganizationSucceeded = actionCreator(ActionTypes.FIND_ORGANIZATION_SUCCEEDED);
export const findOrganizationFailed = actionCreator(ActionTypes.FIND_ORGANIZATION_FAILED);

export const createRequest = actionCreator(ActionTypes.CREATE_REQUEST);
export const createRequestSucceeded = actionCreator(ActionTypes.CREATE_REQUEST_SUCCEEDED);
export const createRequestFailed = actionCreator(ActionTypes.CREATE_REQUEST_FAILED);

export const requestDocuments = actionCreator(ActionTypes.REQUEST_DOCUMENTS);
export const requestDocumentsSucceeded = actionCreator(ActionTypes.REQUEST_DOCUMENTS_SUCCEEDED);
export const requestDocumentsFailed = actionCreator(ActionTypes.REQUEST_DOCUMENTS_FAILED);

export const requestDocumentsList = actionCreator(ActionTypes.REQUEST_DOCUMENTS_LIST);
export const requestDocumentsListSucceeded = actionCreator(ActionTypes.REQUEST_DOCUMENTS_LIST_SUCCEEDED);
export const requestDocumentsListFailed = actionCreator(ActionTypes.REQUEST_DOCUMENTS_LIST_FAILED);

export const requestNumber = actionCreator(ActionTypes.REQUEST_NUMBER);
export const requestNumberSucceeded = actionCreator(ActionTypes.REQUEST_NUMBER_SUCCEEDED);
export const requestNumberFailed = actionCreator(ActionTypes.REQUEST_NUMBER_FAILED);